import { useMemo } from "react";
import { UnidadeUnificadaResponse } from "./../typings/index";

function useUnidadesUnificadasColumns() {
  return useMemo(() => {
    return [
      {
        title: "Responsável",
        render: (original: UnidadeUnificadaResponse) => (
          <div>{original.responsavel.nome}</div>
        ),
      },
      {
        title: "Quantidade de unidades",
        render: (original: UnidadeUnificadaResponse) => (
          <div>
            {original.unidades.length === 1
              ? "Uma unidade"
              : `${original.unidades.length} unidades`}
          </div>
        ),
      },
    ];
  }, []);
}

export default useUnidadesUnificadasColumns;
